import { getPageSlug } from '../utils/getPageSlug';
import { prefetchPublicPage } from './prefetchPage';
export function prefetchCurrentRouteChunk() {
  const slug = getPageSlug();
  if (!slug) return;
  prefetchPublicPage(slug);
}